export default __webpack_public_path__ + "static/media/video.4f039e07.mp4";